/**
 * Created by akrio on 2018/3/26.
 */
import moment from "moment-timezone";
import jstz from "jstz";
/**
 * 获取所有时区名字
 */
export const timezones = moment.tz
  .names()
  .filter((name) => name.indexOf("/") !== -1 && name.indexOf("Etc") === -1);
/**
 * 获取当前时区名称
 */
export const currentName = jstz.determine().name();
